<template>
    <div>
      <Loader :active="loading" mensaje="Verificando sus datos..." />
      <v-container class="text-center">
        <img class="mb-5" width="50%" src="../assets/images/logo_siscure.jpeg" alt="">
        <h1 class="mb-5">Bienvenido
          <small class="font-weight-light">
            SISControl
          </small>
        </h1>
        <form @submit.prevent="login">
          <v-text-field v-model="numeroEmpleado" autofocus label="Numero de empleado" placeholder="Ingrese su numero de empleado" filled ></v-text-field>
          <v-text-field v-model="password" type="password" label="Contraseña" placeholder="Ingrese su contraseña" filled ></v-text-field>
          <v-btn type="submit" color="primary" block>
            Entrar
          </v-btn>
        </form>
      </v-container>
    </div>
</template>
<script>
import { session } from '../services/session'
import Loader from '../components/Loader'
export default {
  name: 'Auth',
  components: {
    Loader
  },
  data () {
    return {
      loading: false,
      numeroEmpleado: '',
      password: ''
    }
  },
  methods: {
    async login () {
      try {
        this.loading = true
        const resp = await session.login(this.numeroEmpleado, this.password)

        console.log({ resp })

        if (resp) {
          this.$router.push('/asistencias')
        }
      } catch (err) {
        this.$toasted.show(err.message, {
          icon: 'close-circle',
          theme: 'bubble',
          type: 'error',
          position: 'bottom-center',
          duration: 5000
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
  * {
    background-color: rgb(247, 247, 247) !important;
    background-size: cover;
  }
</style>
